import React, { useState } from 'react';
import { X } from 'lucide-react';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    {
      url: 'https://customer-assets.emergentagent.com/job_ice-maestro/artifacts/5e1be5ta_pic.jpg',
      title: 'Hristina Vassileva',
      category: 'Professional Profile'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_ice-maestro/artifacts/gjcmroh4_VASSILEVA%20%281%29.jpg',
      title: 'On Ice Performance',
      category: 'Competition'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_ice-maestro/artifacts/f97s7fdd_IMG_20240811_101147.jpg',
      title: 'Coaching Moment',
      category: 'Coaching'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_ice-maestro/artifacts/saeewtml_viber_image_2025-12-29_15-59-09-727.jpg',
      title: 'Competition Success',
      category: 'Students & Awards'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_ice-maestro/artifacts/onxyn2t5_viber_image_2025-12-29_16-01-54-909.jpg',
      title: 'Award Ceremony',
      category: 'Coaching Excellence'
    }
  ];

  return (
    <section id="gallery" className="py-24 bg-slate-900">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-4 py-2 bg-sky-600 text-white rounded-full text-sm font-semibold mb-6">
            Gallery
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Moments on Ice
          </h2>
          <p className="text-xl text-slate-300">
            A glimpse into the world of elite figure skating training and performance.
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-xl cursor-pointer aspect-square"
              onClick={() => setSelectedImage(image)}
            >
              <img
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className="text-sky-300 text-sm font-semibold mb-1">
                    {image.category}
                  </div>
                  <div className="text-white text-lg font-bold">
                    {image.title}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-slate-900/95 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-sky-400 transition-colors"
            onClick={() => setSelectedImage(null)}
          >
            <X size={32} />
          </button>
          <div className="max-w-5xl w-full">
            <img
              src={selectedImage.url}
              alt={selectedImage.title}
              className="w-full h-auto rounded-lg"
            />
            <div className="text-center mt-6">
              <div className="text-sky-400 text-sm font-semibold mb-2">
                {selectedImage.category}
              </div>
              <div className="text-white text-2xl font-bold">
                {selectedImage.title}
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;